/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    view: {
        'class': 'type-item',
        tag: 'a',
        href: nb.bind('href'),
        target: '_blank',
        $html: [{
            'class': 'item-content abs-full',
            $html: [{
                'class': 'item-img',
                $html: {
                    tag: 'img',
                    alt: nb.bind('nameEn'),
                    src: nb.bind('imgUrl')
                }
            }, {
                'class': 'item-hover abs-full',
                $html: [{
                    'class': 'item-name uk-text-truncate',
                    $text: nb.bind('nameCn')
                }, {
                    'class': 'item-en uk-text-truncate',
                    $text: nb.bind('nameEn')
                }, {
                    'class': 'item-pattern',
                    $html: [{
                        tag: 'span',
                        $text: nb.bind('counter')
                    }, {
                        tag: 'span',
                        $text: nb.bind('itemsText')
                    }]
                }]
            }]
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/wineType/TypeItem.js
// module id = 531
// module chunks = 6